import type { SumElementMultipliers } from "./types";

export const sumElementMultipliers: SumElementMultipliers = ({ elements }) =>
  elements.reduce((total, element) => total + element.multiplier, 0);
